import { _s } from '@/locale';

export type Section = {
  label: string;
  path?: string;
};

export const TERMS_URLS = {
  USAGE: 'https://help.bokadirekt.se/sv/articles/14015859-allmanna-villkor-bokadirekt-och-konsument',
  COUPON: 'https://help.bokadirekt.se/sv/articles/13844269-allmanna-villkor-vid-kop-av-present-klipp-och-friskvardskort',
  ETHICAL_POLICY: 'https://help.bokadirekt.se/sv/articles/13856845-etisk-policy',
  PRIVACY_POLICY: 'https://help.bokadirekt.se/sv/articles/13856863-integritetspolicy',
  TERMS_COLLECTION: 'https://help.bokadirekt.se/sv/collections/3411947-allmanna-villkor-och-policy-for-konsument-och-slutkund',
} as const;

const baseTranslationKey = 'constants.terms';

export enum TermLinkIdentifier {
  PAYMENT = 'payment',
  USAGE = 'usage',
  COUPON = 'coupon',
}

export const TERMS_NAVIGATION_LINKS = [
  {
    label: _s(`${baseTranslationKey}.link.payment`),
    to: TERMS_URLS.USAGE,
    identifier: TermLinkIdentifier.PAYMENT,
  },
  {
    label: _s(`${baseTranslationKey}.link.usage`),
    to: TERMS_URLS.USAGE,
    identifier: TermLinkIdentifier.USAGE,
  },
  {
    label: _s(`${baseTranslationKey}.link.coupon`),
    to: TERMS_URLS.COUPON,
    identifier: TermLinkIdentifier.COUPON,
  },
] as const;
